import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useConfirmImageResourceMutation = createMutationHook(
  MembershipsCreatorApiClient.confirmImageResource,
  {
    mutationKey: ['confirmImageResource'],
  },
)
